if (window.innerWidth < 992) {
  document.querySelectorAll('.tooltip i').forEach((el) => {
    const nextSibling = el.nextElementSibling;

    if (!nextSibling || !nextSibling.classList.contains('tooltip-content')) {
      return;
    }

    nextSibling.classList.toggle('visible');
  });
}
